import { Stack } from '@mui/material';
import { getPublicApiReadableInfo } from '@/api/errors';
import { MonospaceTypography } from './styled-components';

export const MutationErrorFallback = ({ error }: { error: unknown }) => {
  const [message, traceId] = getPublicApiReadableInfo(error);
  return <MutationErrorFallbackContent message={message} traceId={traceId} />;
};

export const MutationErrorFallbackContent = ({ message, traceId }: { message: string; traceId?: string }) => (
  <Stack
    sx={{
      gap: 0.5,
    }}
  >
    <span>{message}</span>
    {traceId && <MonospaceTypography>Trace ID: {traceId}</MonospaceTypography>}
  </Stack>
);
